module.exports = __webpack_public_path__ + "img/shop-service-filter-black.ff185e99.png";